(function () {
  "use strict";

  angular
    .module("partners")
    .controller("ManagePartnersListController", ManagePartnersListController);

  ManagePartnersListController.$inject = [
    "ManagePartnersService",
    "ExpoService",
    "$uibModal",
    "$q",
    "eventTypes",
    "expos",
    "virtualFairs",
  ];

  function ManagePartnersListController(
    ManagePartnersService,
    ExpoService,
    $uibModal,
    $q,
    eventTypes,
    expos,
    virtualFairs
  ) {
    var vm = this;

    vm.partners = null;

    vm.expos = [];
    vm.expoSelected = [];
    vm.expoName = '';
    vm.exposAll = [
      {
        name: "--- All ---",
      },
    ];

    vm.loadExpos = loadExpos;
    vm.getByFilter = getByFilter;
    vm.openInformation = openInformation;
    vm.openRegisteredInformation = openRegisteredInformation;
    vm.remove = remove;
    vm.statistics = statistics;
    vm.event_type = "expo";

    /* PAGINATION */
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.page = 1;

    activate();

    function setPage(page) {
      vm.currentPage = page;
    }

    function pageChanged(page) {
      vm.page = vm.currentPage;
      vm.getByFilter();
    }

    function activate() {
      vm.eventTypes = eventTypes;
      vm.expos = expos;
      vm.virtualFairs = virtualFairs;
    }

    function loadExpos() {
      ExpoService.getExposForSelect()
        .then(function (response) {
          vm.expos = vm.exposAll.concat(response.data);
        })
        .catch(function (err) {});
    }

    function getByFilter() {
      vm.query = {};
      vm.query["event_type"] = vm.event_type;
      vm.query["event_id"] = vm.expoSelected.id;
      vm.query["expo_name"] = vm.expoName;
      vm.query["page"] = vm.page;

      ManagePartnersService.getByFilter(vm.query)
        .then(function (response) {
          vm.partners = response.data.data;
          vm.totalItems = response.data.total;
          vm.itemsPerPage = response.data.per_page;
          vm.setPage(response.data.current_page);
        })
        .catch(function (err) {});
    }

    function openInformation(partner) {
      $uibModal.open({
        templateUrl: "templates/partners/show/template.modal.html",
        controller: "PartnerModalController",
        controllerAs: "vm",
        resolve: {
          partner: function () {
            return partner;
          },
        },
      });
    }

    function openRegisteredInformation(partner) {
      $uibModal.open({
        templateUrl: "templates/partners/show/registered.modal.html",
        controller: "PartnerModalController",
        controllerAs: "vm",
        resolve: {
          partner: function () {
            return partner;
          },
        },
      });
    }

    function remove(partner) {
      alertify
        .confirm("This action is irreversible!")
        .set("labels", {
          ok: "Ok",
          cancel: "Cancelar",
        })
        .set("title", "Do you really want to delete this partner?")
        .set("onok", function () {
          ManagePartnersService.destroy(partner.id).then(function () {
            vm.partners.splice(vm.partners.indexOf(partner), 1);
            alertify.notify("Partner removed", "success", 3);
          });
        })
        .show();
    }

    function statistics(partner) {
      vm.flag = false;
      vm.query = {};

      vm.query["partner_id"] = partner.id;
      vm.query["expo_id"] = partner.event_id;

      ManagePartnersService.statistics(vm.query)
        .then(function (response) {
          $uibModal.open({
            templateUrl: "templates/partners/statistics/reportFilter.html",
            controller: "PartnersStatisticsController",
            controllerAs: "partnersStatistics",
            size: "lg",
            resolve: {
              statistics: function () {
                return response.data;
              },
              partner: function () {
                return partner;
              },
            },
          });
        })
        .catch(function (err) {});

      vm.flagForViewGraph = true;
    }
  }
})();
